<div *ngIf="userDocument"
     class="h-100"
     app-pspdfkit
     [pspdfkitId]="userDocument.pspdfkitId"
     [allowAnnotations]="true"
     description="userDocument.fileName"></div>

